/** Redoslijed prikaza: Last Minute → New → ostalo → Popunjeno; unutar grupe po datumu. */

function tourTagSortPriority(tag) {
  if (tag === "Last Minute") return 0;
  if (tag === "New") return 1;
  if (tag === "Popunjeno") return 3;
  return 2;
}

export function compareToursForDisplay(a, b) {
  const priorityDiff = tourTagSortPriority(a?.tag) - tourTagSortPriority(b?.tag);
  if (priorityDiff !== 0) return priorityDiff;
  return new Date(a?.date || 0) - new Date(b?.date || 0);
}

export function sortToursForDisplay(tours) {
  if (!Array.isArray(tours)) return [];
  return [...tours].sort(compareToursForDisplay);
}
